import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from '../base.entity';

/**
 * Join table: groups visible to holders of a specific RBAC role. A
 * conversation with visibility=role is accessible (read + post) by
 * any user holding any of the linked roles. Posting auto-creates a
 * chat_participant row.
 *
 * Multiple rows per conversation → union across roles. Role matching
 * goes through _rbac_role__user for direct assignments.
 */
@Entity('chat_conversation_role')
@Index('idx_chat_conversation_role_convo', ['conversationId'])
@Index('idx_chat_conversation_role_role', ['rbacRoleId'])
@Index('uq_chat_conversation_role', ['conversationId', 'rbacRoleId'], {
	unique: true,
})
export class ChatConversationRoleEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_chat_conversation__id',
		unsigned: true,
	})
	public conversationId!: number;

	@Column('int', {
		name: 'fk_rbac_role__id',
		unsigned: true,
	})
	public rbacRoleId!: number;
}
